import PropTypes from 'prop-types';
import { BsReceipt } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';

import { useCreatePortalSession } from '../../../../models/billing/mutations';

export const BillingPortalLink = ({ className }) => {
	const createPortal = useCreatePortalSession();

	const handleOpenPortal = async () => {
		try {
			const { data } = await createPortal.mutateAsync();
			if (data?.url) window.location.href = data.url;
		} catch {
			// Global mutation error handling surfaces the toast.
		}
	};

	return (
		<Button
			variant="outline"
			size="sm"
			onClick={handleOpenPortal}
			loading={createPortal.isPending}
			className={className}
		>
			{!createPortal.isPending && <BsReceipt className="h-4 w-4" />}
			Rechnungen & Zahlungsmethode verwalten
		</Button>
	);
};

BillingPortalLink.propTypes = {
	className: PropTypes.string,
};
